import { IResourceComponentsProps } from "@pankod/refine-core";
import { RESOURCE_PATH } from "scripts/site";
import { LocationForm } from "components/manage/locationForm";

export const CountryEdit: React.FC<IResourceComponentsProps> = () => {
    return (
        <LocationForm entity={RESOURCE_PATH.COUNTRY} mode="edit" />
    );
};